import { themeStyle } from "../../components/Components";
import React, { useEffect, useState, useRef, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Sidebar from "../../components/Sidebar";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import { API_URL, MAIN_TITLE, alertMessage } from "../../actions/auth";
import Paper from "@mui/material/Paper";
import Fab from "@mui/material/Fab";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import PublishIcon from "@mui/icons-material/Publish";
import Avatar from "@mui/material/Avatar";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import Drawer from "@mui/material/Drawer";
import AddBoxIcon from "@mui/icons-material/AddBox";
import Checkbox from "@mui/material/Checkbox";
import moment from "moment";
import DeleteIcon from "@mui/icons-material/Delete";
import ButtonBase from "@mui/material/ButtonBase";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

function AllRoutes() {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const [routes, setRoutes] = useState([]);
  const [drivers, setDrivers] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [routeID, setRouteID] = useState("");
  const [busNumber, setBusNumber] = useState("");
  const [area, setArea] = useState("");

  const [open2, setOpen2] = useState(false);
  const [selectedRoute, setSelectedRoute] = useState({ route_id: "" });
  const [selectedDriver, setSelectedDriver] = useState({
    user_id: "",
    full_name: "",
  });

  function createAlert(type, title, message) {
    dispatch(alertMessage(type, title, message));
  }

  if (state.auth.refresh == "REFRESH_DATA") {
    getData();
    dispatch({ type: "REFRESH_DATA", payload: null });
  }

  useEffect(() => {
    if (state.auth.isLoading) {
      dispatch({ type: "ENTRY_PAGE", payload: window.location.pathname });
      navigate("/", { replace: true });
    } else {
      getData();
    }
  }, []);

  const [toggleDrawer, setToggleDrawer] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  function getDriversList() {
    var drvrs = drivers.map((driver, index) => (
      <MenuItem value={driver}>{driver["full_name"]}</MenuItem>
    ));

    return drvrs;
  }

  function addNewRoute() {
    setIsSubmitting(true);
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,
        "Content-Type": "application/json",
      },
    };

    body["institution_id"] = state.auth.user.institution_id;
    body["route_id"] = routeID;
    body["bus_number"] = busNumber;
    body["area"] = area;
    body["driver"] = selectedDriver;
    axios
      .post(API_URL + "/add_route", body, config)
      .then((res) => {
        createAlert("SUCCESS", "Success", "New Route added.");
        setIsSubmitting(false);
        setRouteID("");
        setBusNumber("");
        setArea("");
        getData();
      })
      .catch((err) => {
        createAlert("ERROR", "Error", "An error occured.");
        setIsSubmitting(false);
      });
  }

  function deleteItem() {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,
        "Content-Type": "application/json",
      },
    };

    body["route_id"] = selectedRoute["route_id"];
    body = JSON.stringify(body);

    axios
      .post(API_URL + "/delete_route", body, config)
      .then((res) => {
        setOpen2(false);
        getData();
      })
      .catch((err) => {
        createAlert("ERROR", "Error", "An error occured.");
      });
  }

  function getData() {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,
        "Content-Type": "application/json",
      },
    };

    body["institution_id"] = state.auth.user.institution_id;
    body = JSON.stringify(body);

    axios
      .post(API_URL + "/get_routes", body, config)
      .then((res) => {
        setRoutes(res.data);
        axios
          .post(API_URL + "/get_drivers", body, config)
          .then((res) => {
            setDrivers(res.data);
            setSelectedDriver(res.data[0]);
            setIsLoading(false);
            setToggleDrawer(false);
          })
          .catch((err) => {
            createAlert("ERROR", "Error", "An error occured.");
          });
      })
      .catch((err) => {
        createAlert("ERROR", "Error", "An error occured.");
      });
  }

  function getContent() {
    if (routes.length == 0) {
      return (
        <div
          style={{
            marginTop: "200px",
            height: "100px",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <Fab
              size="large"
              style={{
                border: "3px solid #aaa",
                boxShadow: "none",
                backgroundColor: "transparent",
              }}
              aria-label="add"
            >
              <PriorityHighIcon
                style={{
                  color: "grey",
                }}
              />
            </Fab>
            <br />
            <h4 style={{ color: "grey" }}>No routes have been added yet.</h4>
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ width: "100vw", fontSize: "18px" }}>
          <h2>All Routes</h2>
          <Grid
            container
            style={{
              paddingBottom: "5px",
              marginBottom: "5px",
              borderBottom: "1px solid #aaa",
            }}
          >
            <Grid item md={1}>
              Route ID
            </Grid>
            <Grid item md={2}>
              Bus Number
            </Grid>
            <Grid item md={5}>
              Assigned Area
            </Grid>
            <Grid item md={3}>
              Primary Driver Name
            </Grid>
            <Grid
              item
              md={1}
              style={{ display: "flex", justifyContent: "center" }}
            >
              Delete
            </Grid>
          </Grid>
          {routes.map((item, index) => (
            <Grid container style={{ marginTop: "15px" }}>
              <Grid item md={1}>
                {item.route_id}
              </Grid>

              <Grid item md={2}>
                {item.bus_number}
              </Grid>
              <Grid item md={5}>
                {item.area}
              </Grid>
              <Grid item md={3}>
                {item.primary_driver}
              </Grid>
              <Grid
                item
                md={1}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <ButtonBase
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    backgroundColor: "#ff3333",
                    padding: "5px",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "6px",
                  }}
                  onClick={() => {
                    setSelectedRoute(item);
                    setOpen2(true);
                  }}
                >
                  <DeleteIcon style={{ color: "white", fontSize: "18px" }} />
                </ButtonBase>
              </Grid>
            </Grid>
          ))}
        </div>
      );
    }
  }

  if (!state.auth.isLoading) {
    if (state.auth.isAuthenticated) {
      if (state.auth.user.is_transport) {
        return (
          <Fragment>
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              open={open2}
              onClose={() => setOpen2(false)}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={open2}>
                <div
                  style={{ borderRadius: "15px",
                    position: "absolute",
                    top: "50%",
                    backgroundColor: "white",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    padding: "20px",
                  }}
                >
                  <div style={{ marginTop: "-25px" }}>
                    <div
                      style={{
                        marginTop: "20px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <h3>Delete this item?</h3>
                      <IconButton size="small">
                        <CloseIcon
                          onClick={() => setOpen2(false)}
                          style={{ color: themeStyle.primaryColor }}
                        />
                      </IconButton>
                    </div>

                    <span>
                      This action cannot be reversed. It will be deleted
                      forever.
                    </span>
                    <br></br>
                    <br></br>
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Button
                        onClick={() => deleteItem()}
                        style={{ height: "30px", backgroundColor: themeStyle.primaryColor }}
                        variant="contained"
                      >
                        Yes
                      </Button>
                      <Button
                        style={{ height: "30px", marginLeft: "10px", backgroundColor: themeStyle.primaryColor }}
                        variant="contained"
                        onClick={() => setOpen2(false)}
                      >
                        No
                      </Button>
                    </div>
                  </div>
                </div>
              </Fade>
            </Modal>
            <Drawer
              anchor={"right"}
              open={toggleDrawer}
              onClose={() => setToggleDrawer(false)}
            >
              {isSubmitting ? (
                <div
                  style={{ borderRadius: "15px",
                    marginTop: "60px",
                    padding: "20px",
                    width: "400px",
                    backgroundColor: "white",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <CircularProgress />
                  <h3>Uploading in progress...</h3>
                </div>
              ) : (
                <div style={{ padding: "15px", marginTop: "23px" }}>
                  <div
                    style={{
                      marginTop: "45px",
                    }}
                  >
                    <span
                      style={{
                        color: themeStyle.primaryColor,
                        fontSize: "14px",
                      }}
                    >
                      Route ID
                    </span>
                  </div>

                  <TextField
                    style={{ marginTop: "2px", marginBottom: "15px" }}
                    value={routeID}
                    fullWidth
                    size="small"
                    onChange={(e) => setRouteID(e.target.value)}
                    placeholder={"Route ID"}
                    variant="outlined"
                  />
                  <br></br>
                  <span
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                    }}
                  >
                    Bus Number
                  </span>
                  <TextField
                    style={{ marginTop: "2px", marginBottom: "15px" }}
                    value={busNumber}
                    fullWidth
                    size="small"
                    onChange={(e) => setBusNumber(e.target.value)}
                    placeholder={"Bus Number"}
                    variant="outlined"
                  />

                  <br></br>
                  <span
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                    }}
                  >
                    Area
                  </span>
                  <TextField
                    style={{ marginTop: "2px", marginBottom: "15px" }}
                    value={area}
                    fullWidth
                    size="small"
                    onChange={(e) => setArea(e.target.value)}
                    placeholder={"Area"}
                    variant="outlined"
                  />

                  <br></br>
                  <span
                    style={{
                      color: themeStyle.primaryColor,
                      fontSize: "14px",
                    }}
                  >
                    Primary Driver
                  </span>
                  <Select
                    value={selectedDriver}
                    onChange={(e) => setSelectedDriver(e.target.value)}
                    style={{
                      marginTop: "2px",
                      height: "40px",
                      marginBottom: "5px",
                    }}
                    fullWidth
                    variant={"outlined"}
                  >
                    {getDriversList()}
                  </Select>
                  <br></br>
                  <br></br>
                  <Box
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                      height: "35px",
                    }}
                  >
                    <Button
                      onClick={() => addNewRoute()}
                      fullWidth
                      variant="contained"
                      style={{
                        backgroundColor: themeStyle.primaryColor,
                        boxShadow: "none",
                      }}
                    >
                      <h4>Add New Route</h4>
                    </Button>
                  </Box>
                </div>
              )}
            </Drawer>
            <div
              style={{
                height: "50px",
                width: "225px",
                padding: "5px 10px",
                borderRadius: "50px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: "none",
                backgroundColor: themeStyle.primaryColor,
                position: "fixed",
                bottom: 30,
                right: 30,
                cursor: "pointer",
              }}
              onClick={() => setToggleDrawer(true)}
              aria-label="add"
            >
              <AddBoxIcon
                style={{
                  color: "white",
                  marginRight: "15px",
                  fontSize: "30px",
                }}
              />
              <div
                style={{
                  color: "white",
                  fontSize: "18px",
                  fontWeight: "bold",
                }}
              >
                Add New Route
              </div>
            </div>
            <Sidebar />
            <div
              style={{ borderRadius: "15px",
                margin: "38px 40px 20px 90px",
                backgroundColor: "white",
                display: "flex",
              }}
            >
              {getContent()}
            </div>
          </Fragment>
        );
      } else {
        createAlert("ERROR", "Permission Denied.", "Please Login as Student");
        dispatch({
          type: "AUTH_ERROR",
        });
        dispatch({ type: "AUTH_ERROR" });
      }
    } else {
      dispatch({ type: "AUTH_ERROR" });
    }
  } else {
    return (
      <div
        style={{ borderRadius: "15px",
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "white",
          marginTop: "46vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
}

export default AllRoutes;
